import BREAKPOINTS from "../static/breakpoints";

const isScreenWidthGreaterThan = (width: number) => window.innerWidth >= width;
const isScreenWidthLessThan = (width: number) => window.innerWidth < width;
const isScreenWidthBetween = (a: number, b: number) => window.innerWidth >= a && window.innerWidth <= b;

export const ScreenServices = {
  isXSmallScreen: () => isScreenWidthLessThan(BREAKPOINTS.XS),
  isSmallScreen: () => isScreenWidthGreaterThan(BREAKPOINTS.SM),
  isMediumScreen: () => isScreenWidthGreaterThan(BREAKPOINTS.MD),
  isLargeScreen: () => isScreenWidthGreaterThan(BREAKPOINTS.LG),
  isXLargeScreen: () => isScreenWidthGreaterThan(BREAKPOINTS.XL),
  isMediumBreakpoint: () => isScreenWidthLessThan(BREAKPOINTS.LG),
  isMobileBreakpoint: () => isScreenWidthLessThan(BREAKPOINTS.MD),
  isDesktopBreakpoint: () => isScreenWidthGreaterThan(BREAKPOINTS.MD),
  isBetweenMdAndLg: () => isScreenWidthBetween(BREAKPOINTS.MD, BREAKPOINTS.LG),
  isBetweenLgAndXL: () => isScreenWidthBetween(BREAKPOINTS.LG, BREAKPOINTS.XL),
};
